/**
 * Returns the dimensions of an element. Will optionally include any padding and borders when `type` equals `'border-box'`.
 */
export function getElementDimensions(element, type) {
    if (type === 'content-box') {
        return {
            width: element.clientWidth,
            height: element.clientHeight
        };
    }
    else {
        const rect = element.getBoundingClientRect();
        return {
            width: rect.width,
            height: rect.height
        };
    }
}
//# sourceMappingURL=get-element-dimensions.js.map